export default "__VITE_ASSET__xOEo2TGy__"